// extracted by mini-css-extract-plugin
export default {"button":"NavButton_button__ZYgiW","selected":"NavButton_selected__30QpP","text":"NavButton_text__uzccA"};